
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { TabDto } from '@/api/goodsModule';
import draggable from 'vuedraggable';
import shakeImage from './shake-image.vue';
import {
  getStoreUserNavbarList,
  updateStoreUserNavbar,
  getStoreUserNavbarTempletList
} from '@/api/goodsModule';

@Component({
  name: 'more',
  components: {
    draggable,
    shakeImage,
  },
})
export default class more extends Vue {
  @Getter companyId!: string;
  @Getter tabModules!: Array<TabDto>;
  @Action setTabModules!: (val: Array<TabDto>) => void;

  isShow = false;
  tabs1 = [];
  tabs2 = [];
  disabled = true;
  isDragging = false;
  isMaxLen = 4;
  isMax = false;

  mounted() {
    this.getNavbarList();
    this.tabs2 = this.handledTabs;
    if (this.$route.query.isShake === 'shake') {
      this.$eventBus.$emit('startShake');
      this.disabled = false;
    }
  }

  get handledTabs() {
    return this.tabModules.filter((t) => t.isShow);
  }

  async getNavbarList() {
    const { data } = await getStoreUserNavbarTempletList({ storeId: this.companyId })
    // const { data } = await getStoreUserNavbarList({ storeId: this.companyId });
    let arr = []
    this.tabs2.forEach((item) => arr.push(item.route))
    this.tabs1 = data.filter((item) => !arr.includes(item.route));
    console.log(this.tabs1, this.tabs2);
  }

  show() {
    this.isShow = true;
  }

  onStart() {
    this.$eventBus.$emit('startShake');
  }

  onEnd() {
    this.$eventBus.$emit('startShake');
  }

  handleDone() {
    // 触发全局停止抖动;
    this.$eventBus.$emit('stopShake');
    this.disabled = true;
    updateStoreUserNavbar({
      storeId: this.companyId,
      navbarList: this.tabs2,
    }).then((res) => {
      this.$toast(res.msg);
      this.setTabModules(this.tabs2);
      this.$router.back();
    });
  }

  handlePress() {
    this.disabled = false;
  }

  @Watch('tabs1')
  tabs1Change(val: any) {
    val.forEach((item: any) => {
      item.isShow = false;
      if (!item.applicationLogo.includes('-active')) {
        item.applicationLogo = `${
          item.applicationLogo.split('.')[0]
        }-active.png`;
      }
    });
  }

  @Watch('tabs2')
  tabs2Change(val: any) {
    if (val.length > this.isMaxLen) {
      this.isMax = true;
    }
    val.forEach((item: any) => {
      item.isShow = true;
      if (item.applicationLogo.includes('-active')) {
        item.applicationLogo = item.applicationLogo.replace('-active', '');
      }
    });
  }
}
